import { getDeviceId } from "utilities/getDeviceId";
import { isWebView } from "@/utilities/display";
import { getBridge } from "@/utilities/bridge";
import { VERSION } from "appConfig";
import * as Sentry from "@sentry/gatsby";

let initialisedNative = false;

export const identifyAnalytics = (
  userId: string,
  traits?: Record<string, unknown>,
) => {
  if (typeof window === "undefined") {
    return;
  }

  const payload = {
    persistentDeviceId: getDeviceId(),
    clientVersion: VERSION,
    userId,
    ...(traits || {}),
  };

  window.analytics?.identify(userId, payload);
  Sentry.setUser({ id: userId });

  getBridge().send.analyticsIdentify(payload);
  initialisedNative = true;
};

export const resetAnalytics = () => {
  if (typeof window === "undefined") {
    return;
  }

  if (window.analytics) {
    window.analytics.reset();
  }

  Sentry.setUser(null);

  if (isWebView()) {
    getBridge().send.analyticsReset();
  }
};

export const sendNativeIdentifyIfNeeded = (userId: string | null) => {
  if (userId && !initialisedNative) {
    getBridge().send.analyticsIdentify({
      persistentDeviceId: getDeviceId(),
      clientVersion: VERSION,
      userId,
    });
    initialisedNative = true;
  }
};
